<div>
    <sdps-panel control-type="none">
        <div id="page-error-container">
            <div id="documentWarning-icon"></div>
            <div id="primary-text">{{ineligibleAccountPrimaryText}}</div>
            <div id="secondary-text" *ngIf="!isEAuth">{{ineligibleAccountSecondaryText}}</div>
        </div>
    </sdps-panel>
</div>